import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { useAppManager } from 'core/hooks';

import styled from 'styled-components';
import { Heading, Button } from 'components';

import { Table } from 'libs/connection';
import { SortByAction, FilterByAction } from 'libs/connection/actions';

import { ChangePortalBanner } from 'apps/client/components/ChangePortalBanner';

import { Link } from 'core/routing';
import { CenteredButtonWrapper } from 'apps/components/shared';
import { PortalLink } from 'apps/client/components/PortalLink';

import { OrderConnManager } from './connManager';
import { useClientStore, useRouterStore } from '../../hooks';

const OpenOrderButton = ({ node }) => (
  <PortalLink name='order' params={{ orderId: node.decimalId }}>
    <Button
      size='small'
      text='Open'
      outline
      icon='arrow_right'
      iconPosition='right'
    />
  </PortalLink>
);

const ListWrapper = styled.div`
  margin-top: 2rem;
`;

const HeadingWrapper = styled.div`
  display: flex;
  direction: row;
  justify-content: space-between;
`;

const actions = {
  leftActions: [SortByAction, FilterByAction],
  rightActions: [],
};

const OrderList = observer(({ maxItems }) => {
  const clientStore = useClientStore();
  const routerStore = useRouterStore();
  const conn = useAppManager(OrderConnManager, null);

  const { activeSpace } = clientStore;
  const title =
    activeSpace?.spaceType === 'INITIATIVE' ? `Orders` : 'My Orders';

  let bottomButton = null;
  let numRows = conn?.nodes?.length;
  if (!numRows) numRows = 0;
  if (maxItems && maxItems <= numRows) {
    const params = { spacePath: clientStore.activeSpace?.path };
    bottomButton = (
      <CenteredButtonWrapper>
        <Link name='workspace.orders' params={params}>
          <Button
            size='default'
            variant='primary'
            outline
            text='Show all'
            icon='arrow_right'
            iconPosition='right'
          />
        </Link>
      </CenteredButtonWrapper>
    );
  }
  let changePortalBanner = null;
  if (routerStore.route.name !== 'workspace') {
    changePortalBanner = <ChangePortalBanner />;
  }

  return (
    <ListWrapper>
      <HeadingWrapper>
        <Heading level={2} size='large'>
          {title}
        </Heading>
      </HeadingWrapper>
      {changePortalBanner}
      <Table
        {...{
          contentName: 'Orders',
          columns: conn.finalColumns,
          conn,
          actions,
          maxRows: maxItems,
          subRowsAccessor: 'quote.productQuotes',
          RowActionButtons: OpenOrderButton,
        }}
      />
      {bottomButton}
    </ListWrapper>
  );
});

OrderList.propTypes = {
  routerStore: PropTypes.object,
};

export default OrderList;
